// Toggles a product handle in a local wishlist and reflects it with aria-pressed.
const STORAGE_KEY = 'theme-wishlist';

function readList() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
  } catch {
    return [];
  }
}

class SWishlist extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    const button = this.querySelector('button');
    const handle = this.dataset.handle;
    if (!button || !handle) return;
    button.setAttribute('aria-pressed', String(readList().includes(handle)));
    button.addEventListener('click', () => {
      const list = readList();
      const saved = list.includes(handle);
      const next = saved ? list.filter((h) => h !== handle) : [...list, handle];
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      } catch {
        // Storage can be unavailable in private modes; the visual toggle still works for this view.
      }
      button.setAttribute('aria-pressed', String(!saved));
      if (!saved) {
        button.classList.remove('bump-in');
        void button.offsetWidth;
        button.classList.add('bump-in');
      }
    }, { signal: this.#ac.signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }
}

customElements.define('s-wishlist', SWishlist);
